import type {
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import * as React from 'react';
import TextEditor from '../../../components/TextEditor';
import ButtonComponent from '../../../components/UI/Button/Button.component';
import { DRAFT } from '../../../constants/draft.constants';
import type { PostDraftInterface } from '../../../interfaces/post.interface';
import PostDrafts from '../../../pages/Drafts/Drafts';
import './tabs-content.scss';

interface UserDraftsTabProps {
  isLoading: boolean;
  username: string | undefined;
  isModalOpen: boolean;
  handleAddDraft: () => void;
  refetch: (
    variables?: Partial<OperationVariables> | undefined,
  ) => Promise<ApolloQueryResult<any>>;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id: string;
  isEditingDraft: boolean;
  userDraftPosts: PostDraftInterface[];
  error: ApolloError | undefined;
}

const UserDraftsTab = (props: UserDraftsTabProps) => {
  const {
    isLoading,
    username,
    isModalOpen,
    handleAddDraft,
    refetch,
    setIsModalOpen,
    id,
    isEditingDraft,
    userDraftPosts,
    error,
  } = props;

  if (isLoading)
    return (
      <div className="LoadingSpinner" role="status" aria-label="Loading" />
    );

  return (
    <section className="TABS__CONTENT">
      <ButtonComponent
        className="ADD__DRAFT"
        variant="primary"
        onClick={() => {
          handleAddDraft();
        }}
      >
        {DRAFT.CREATE_DRAFT}
      </ButtonComponent>
      <TextEditor
        isModalOpen={isModalOpen}
        refetch={refetch}
        setIsModalOpen={setIsModalOpen}
        userId={id}
        username={username as string}
        isEditing={isEditingDraft as boolean}
      />
      {userDraftPosts === null || userDraftPosts === undefined ? (
        <>No Drafts</>
      ) : (
        <PostDrafts draftPosts={userDraftPosts} />
      )}
      {error && <div>Error {`${JSON.stringify(error, null, 2)}`}</div>}
    </section>
  );
};

export default UserDraftsTab;
